import React from 'react';
import { Outlet } from 'react-router-dom';

const AuthLayout: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#231F20' }}>
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img
            src="https://cdn.prod.website-files.com/619e5a6e8bd4831f9e3f07ed/683ecbb13daaa36bd475b4c3_HITAI_white.svg"
            alt="HITAI"
            className="h-12 mx-auto mb-6"
          />

          {/* Main Title */}
          <h1 className="text-white text-3xl font-bold mb-2">
            Smarter Combat Starts Here
          </h1>

          {/* Subtitle */}
          <p className="text-gray-400 text-lg">
            StrikeVision v0.2 | AI-Powered Combat Analytics
          </p>
        </div>
        <Outlet />
        <div className="mt-8 text-center text-gray-500 text-sm flex items-center justify-center gap-2">
          <img
            src="https://cdn.prod.website-files.com/619e5a6e8bd4831f9e3f07ed/683ecbb13daaa36bd475b4c3_HITAI_white.svg"
            alt="HITAI"
            className="h-4"
          />
          <p>Powered by HITAI | Advanced Combat Analytics</p>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;